// Libraries
import React from 'react';
import uniqBy from 'lodash/uniqBy';

// Components
import {CardBlock, CardText} from 'Components/flowChart/components/NodePreview/components/styled';

// Types
import {IMetadata} from 'Components/flowChart/components/NodePreview/components/NodeUpdateInfo/types';
import {INodePreviewProps} from 'Components/flowChart/components/NodePreview/types';

// Constants
import {BO_LABEL} from 'Components/flowChart/components/NodePreview/components/NodeUpdateInfo/constants';

const PATH = 'components/components/flowChart/components/Card/components/NodeWaitEvent/index.tsx';

export interface INodeUpdateInfo extends INodePreviewProps<IMetadata> {}

const NodeUpdateInfo: React.FC<INodeUpdateInfo> = (props) => {
	try {
		const {
			node: {metadata}
		} = props;
		const {itemTypeId, params, itemTypeDisplay = ''} = metadata;

		const numUpdated = uniqBy(params, 'propertyName')?.length;

		return (
			<>
				<CardBlock>
					<CardText>{`Data object: ${BO_LABEL[itemTypeId] || itemTypeDisplay}`}</CardText>
				</CardBlock>
				<CardBlock>
					<CardText>{`Updated ${numUpdated} attribute(s)`}</CardText>
				</CardBlock>
			</>
		);
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeUpdateInfo',
			args: {props}
		});

		return null;
	}
};

export default NodeUpdateInfo;
